<template>
  <form @submit="handleSubmit">
    <slot />
  </form>
</template>

<script setup lang="ts">
type Emits = {
  (e: 'submit', ev: any): void
}

const emit = defineEmits<Emits>()

const handleSubmit = (ev: any) => {
  ev.preventDefault()
  emit('submit', ev)
}
</script>
